// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { BsPencil, BsCheck, BsX } from "react-icons/bs";
// import { Row, Col, Form } from "react-bootstrap";
// const ProjectView = ({ data, setProjectDetails }) => {
//     const [isEditMode, setIsEditMode] = useState(false);
//     const [editedProjectData, setEditedProjectData] = useState(data);
//     const [clients, setClients] = useState([]);
//     const [currency, setCurrency] = useState('USD');
//     const didFetchRef = useRef(false);
//     const [editField, setEditField] = useState(null);

//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         setEditedProjectData((prevState) => {
//             const updatedData = {
//                 ...prevState,
//                 [name]: value,
//             };

//             // Calculate expenditure_amount if relevant fields change
//             if (name === 'max_expenditure' || name === 'expected_value') {
//                 const maxExpenditure = parseFloat(updatedData.max_expenditure || 0);
//                 const expectedValue = parseFloat(updatedData.expected_value || 0);
//                 const expenditureAmount = (maxExpenditure * expectedValue) / 100;
//                 updatedData.expenditure_amount = isNaN(expenditureAmount) ? 0 : expenditureAmount.toFixed(2);
//             }

//             return updatedData;
//         });
//     };

//     const fetchClients = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             // Fetch all contacts
//             const response = await axios.get(`${backendUrl}/api/contacts`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             const allContacts = response.data.Data; // Assuming the API returns contacts in `Data`
//             setClients(allContacts);
//         } catch (error) {
//             console.error('Error fetching contacts:', error);
//         }
//     };

//     useEffect(() => {
//         if (!didFetchRef.current) {
//             fetchClients();
//             didFetchRef.current = true;
//         }
//     }, []);
//     const calculateExpenditureAmount = () => {
//         const { max_expenditure, expected_value } = editedProjectData;
//         const expenditure = (parseFloat(max_expenditure || 0) * parseFloat(expected_value || 0)) / 100;
//         return isNaN(expenditure) ? 0 : expenditure.toFixed(2);
//     };
//     const handleSave = async () => {


//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             await axios.post(`${backendUrl}/api/projects/${data.id}?_method=PUT`, editedProjectData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'multipart/form-data',
//                     'Tenant-Origin': origin,

//                 },
//             });
//             setProjectDetails((prevDetails) => ({
//                 ...prevDetails,
//                 ...editedProjectData, // Update only the changed fields
//             }));
//             setEditField(null);
//         } catch (error) {

//             console.error('Error saving project details:', error);


//         }
//     };
//     const handleDownload = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem("user-origin");
//             const token = userInfo?.token;

//             // Make the request to the backend to get the file
//             const response = await axios.get(
//                 `${backendUrl}/api/projects/${data.id}/download`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,

//                     },
//                     responseType: "blob", // Ensure the file is fetched as binary data
//                 }
//             );

//             // Log response headers for debugging
//             console.log('Response Headers:', response.headers);

//             const contentDisposition = response.headers['content-disposition'];
//             let fileName;

//             // Check if content-disposition header exists and extract the filename
//             if (contentDisposition) {
//                 const match = contentDisposition.match(/filename="(.+)"/);
//                 if (match) {
//                     fileName = match[1];
//                 }
//             }

//             // Log extracted filename for debugging
//             console.log('Extracted Filename:', fileName);

//             if (!fileName) {
//                 // Fallback if filename is not extracted
//                 fileName = 'downloaded-file';
//             }

//             // Create blob and initiate the download
//             const blob = new Blob([response.data], { type: response.headers['content-type'] });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', fileName);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         } catch (error) {
//             console.error('Error downloading the file:', error);
//         }
//     };

//     const getClientName = (id) => {
//         if (!id || clients.length === 0) return "--";
//         const client = clients.find((coun) => Number(coun.id) === Number(id));
//         return client ? client.name : "--";
//     };
//     const projectTypeOptions = [
//         { value: "1", label: "Project(IN-House)" },
//         { value: "2", label: "Project(Out-Source)" }
//     ];

//     const getProjectTypeLabel = (value) => {
//         const option = projectTypeOptions.find(opt => opt.value === value);
//         return option ? option.label : "--";
//     };
//     const fields = [
//         { name: 'name', label: 'Project Name', type: 'text' },
//         { name: 'code', label: 'Project Code', type: 'text' },
//         { name: 'type', label: 'Project Type', type: 'select', options: projectTypeOptions, format: getProjectTypeLabel },

//         { name: 'client_id', label: 'Client', type: 'select', options: clients.map((coun) => ({ value: coun.id, label: coun.name })), format: getClientName },

//         { name: 'expected_value', label: 'Expected Value', type: 'text' },
//         { name: 'max_expenditure', label: 'Max Expenditure(IN %)', type: 'number' },
//         { name: 'expenditure_amount', label: 'Max Expenditure', type: 'number', readOnly: true },
//         { name: 'start_date', label: 'Expected StartDate', type: 'date' },

//         { name: 'documents', label: 'Project Document', type: 'file' },

//     ];

//     const visibleFields = fields.filter((field) => {
//         if (field.name === 'expenditure_amount') {
//             return editedProjectData.max_expenditure;
//         }
//         return true;
//     });

//     // Group fields into rows (3 fields per row)
//     const rows = [];
//     for (let i = 0; i < visibleFields.length; i += 3) {
//         rows.push(visibleFields.slice(i, i + 3));
//     }


//     const handleFileChange = (e, fieldName) => {
//         const file = e.target.files[0];
//         if (file) {
//             const tempUrl = URL.createObjectURL(file); // Temporary preview
//             setEditedProjectData((prevData) => ({
//                 ...prevData,
//                 [fieldName]: file, // Store the selected file (for upload)
//                 [`${fieldName}Url`]: tempUrl, // Set preview URL for images
//                 [`${fieldName}Name`]: file.name, // Store the file name for display
//             }));
//         }
//     };

//     return (
//         <div className="p-3 font-size-12">
//             <Row>
//                 {visibleFields.map((field, index) => (
//                     <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
//                         <strong className="view-label">{field.label}:</strong>
//                         <div className="editable-container d-flex align-items-center">
//                             {editField === field.name ? (
//                                 <div className="d-flex align-items-center">
//                                     {field.type === "file" ? (
//                                         <Form.Control
//                                             type="file"
//                                             name={field.name}
//                                             onChange={(e) => handleFileChange(e, field.name)}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                             />
//                                     ) : field.type === "select" ? (
//                                         <Form.Select
//                                             name={field.name}
//                                             value={editedProjectData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                             >
//                                             {field.options.map((option, idx) => (
//                                                 <option key={idx} value={option.value}>
//                                                     {option.label}
//                                                 </option>
//                                             ))}
//                                         </Form.Select>
//                                     ) : field.type === "date" ? (
//                                         <Form.Control
//                                             type="date"
//                                             name={field.name}

//                                             value={editedProjectData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                             />
//                                     ) : (
//                                         <Form.Control
//                                             type="text"
//                                             name={field.name}
//                                             value={editedProjectData[field.name] || ""}
//                                             onChange={handleChange}
//                                             autoFocus
//                                             className="form-control form-feild"
//                                             />
//                                     )}
//                                     <BsCheck className="text-success mx-2 font-size-15" onClick={handleSave} style={{ cursor: "pointer", fontSize:"15px" }} />
//                                     <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
//                                 </div>
//                             ) : (
//                                 <div className="hover1">
//                                     {field.name === "documents" ? (
//                                         <span className="hover-field1" onClick={handleDownload} style={{ cursor: "pointer" }}>
//                                             {editedProjectData[`${field.name}Name`] || editedProjectData.tl_registration_doc?.split('/').pop() || "-"}
//                                         </span>
//                                     ) : field.name === "client_id" ? (
//                                         <span className="hover-field1">
//                                             {getClientName(editedProjectData.client_id)}
//                                         </span>
//                                     ) : field.name === "type" ? (
//                                         <span className="hover-field1">{getProjectTypeLabel(editedProjectData.type)}</span>
//                                     ) : field.name === "expenditure_amount" ? (
//                                         <span className="hover-field1">{calculateExpenditureAmount()}</span>
//                                     ) : (
//                                         <span className="hover-field1">{editedProjectData[field.name] || "--"}</span>
//                                     )}
//                                     {field.name !== "expenditure_amount" && (
//                                         <BsPencil className="text-primary pencil-icon1" onClick={() => setEditField(field.name)} />
//                                     )}                                    
//                                     </div>
//                             )}
//                         </div>
//                     </Col>
//                 ))}
//             </Row>
//         </div>
//     );

// };

// export default ProjectView;




import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Row, Col, Card } from "react-bootstrap";
import { 
    FaProjectDiagram, 
    FaCode, 
    FaUser, 
    FaChartLine, 
    FaPercentage,
    FaDollarSign,
    FaCalendarAlt,
    FaFileAlt,
    FaBuilding
} from "react-icons/fa";

const ProjectView = ({ data }) => {
    const [clients, setClients] = useState([]);
    const didFetchRef = useRef(false);

    const fetchClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            const allContacts = response.data.Data;
            setClients(allContacts);
        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    useEffect(() => {
        if (!didFetchRef.current) {
            fetchClients();
            didFetchRef.current = true;
        }
    }, []);

    const handleDownload = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/projects/${data.id}/download`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    responseType: "blob",
                }
            );

            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'project-document';

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="(.+)"/);
                if (match) {
                    fileName = match[1];
                }
            }

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading the file:', error);
        }
    };

    const getClientName = (id) => {
        if (!id || clients.length === 0) return "--";
        const client = clients.find((coun) => Number(coun.id) === Number(id));
        return client ? client.name : "--";
    };

    const projectTypeOptions = [
        { value: "1", label: "Project (IN-House)" },
        { value: "2", label: "Project (Out-Source)" }
    ];

    const getProjectTypeLabel = (value) => {
        const option = projectTypeOptions.find(opt => opt.value === value);
        return option ? option.label : "--";
    };

    const calculateExpenditureAmount = () => {
        const maxExpenditure = parseFloat(data?.max_expenditure || 0);
        const expectedValue = parseFloat(data?.expected_value || 0);
        const expenditure = (maxExpenditure * expectedValue) / 100;
        return isNaN(expenditure) ? "0.00" : expenditure.toFixed(2);
    };

    const getDisplayValue = (value) => {
        return value || "--";
    };

    const formatDate = (dateString) => {
        if (!dateString) return "--";
        try {
            return new Date(dateString).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch (error) {
            return dateString;
        }
    };

    // Group fields by category similar to ClientView
    const fieldGroups = [
        {
            title: "Project Information",
            icon: <FaProjectDiagram className="text-primary" />,
            fields: [
                { 
                    name: 'name', 
                    label: 'Project Name', 
                    icon: <FaProjectDiagram size={14} />, 
                    value: getDisplayValue(data?.name)
                },
                { 
                    name: 'code', 
                    label: 'Project Code', 
                    icon: <FaCode size={14} />, 
                    value: getDisplayValue(data?.code)
                },
                { 
                    name: 'type', 
                    label: 'Project Type', 
                    icon: <FaBuilding size={14} />, 
                    value: getProjectTypeLabel(data?.type)
                },
                { 
                    name: 'client_id', 
                    label: 'Client', 
                    icon: <FaUser size={14} />, 
                    value: getClientName(data?.client_id)
                },
            ]
        },
        {
            title: "Financial Details",
            icon: <FaChartLine className="text-success" />,
            fields: [
                { 
                    name: 'expected_value', 
                    label: 'Expected Value', 
                    icon: <FaDollarSign size={14} />, 
                    value: getDisplayValue(data?.expected_value)
                },
                { 
                    name: 'max_expenditure', 
                    label: 'Max Expenditure (%)', 
                    icon: <FaPercentage size={14} />, 
                    value: getDisplayValue(data?.max_expenditure)
                },
                { 
                    name: 'expenditure_amount', 
                    label: 'Max Expenditure Amount', 
                    icon: <FaDollarSign size={14} />, 
                    value: calculateExpenditureAmount()
                },
            ]
        },
        {
            title: "Timeline & Documents",
            icon: <FaCalendarAlt className="text-warning" />,
            fields: [
                { 
                    name: 'start_date', 
                    label: 'Expected Start Date', 
                    icon: <FaCalendarAlt size={14} />, 
                    value: formatDate(data?.start_date)
                },
                { 
                    name: 'documents', 
                    label: 'Project Document', 
                    icon: <FaFileAlt size={14} />, 
                    value: data?.documents ? (
                        <span 
                            className="text-primary cursor-pointer" 
                            onClick={handleDownload}
                            style={{ cursor: "pointer" }}
                        >
                            {data.documents.split('/').pop()}
                        </span>
                    ) : "No Document"
                },
            ]
        }
    ];

    return (
        <div className="p-3">
            {/* Project Header Card */}
            {/* <Card className="mb-4 shadow-sm border-0">
                <Card.Body className="text-center">
                    <div className="d-flex align-items-center justify-content-center mb-3">
                        <div className="position-relative">
                            <div 
                                className="rounded-circle d-flex align-items-center justify-content-center bg-primary text-white fw-bold"
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    fontSize: '1.5rem',
                                    border: '4px solid #e9ecef'
                                }}
                            >
                                <FaProjectDiagram size={30} />
                            </div>
                        </div>
                    </div>
                    <h4 className="fw-bold text-dark mb-1">{getDisplayValue(data?.name)}</h4>
                    <p className="text-muted mb-2">Project Code: {getDisplayValue(data?.code)}</p>
                    <div className="d-flex justify-content-center gap-3">
                        {data?.client_id && (
                            <div className="d-flex align-items-center text-muted">
                                <FaUser className="me-2" />
                                <small>{getClientName(data.client_id)}</small>
                            </div>
                        )}
                        {data?.start_date && (
                            <div className="d-flex align-items-center text-muted">
                                <FaCalendarAlt className="me-2" />
                                <small>{formatDate(data.start_date)}</small>
                            </div>
                        )}
                    </div>
                </Card.Body>
            </Card> */}

            {/* Project Details Sections */}
            {fieldGroups.map((group, groupIndex) => (
                <Card key={groupIndex} className="mb-4 shadow-sm border-0">
                    <Card.Header className="bg-light border-0 py-3">
                        <div className="d-flex align-items-center">
                            {group.icon}
                            <h5 className="mb-0 ms-2 fw-semibold text-dark">{group.title}</h5>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Row className="g-0">
                            {group.fields.map((field, fieldIndex) => (
                                <Col md={6} key={fieldIndex}>
                                    <div className="p-3 border-bottom border-end client-detail-item">
                                        <div className="d-flex align-items-start">
                                            <div className="text-muted me-3 mt-1">
                                                {field.icon}
                                            </div>
                                            <div className="flex-grow-1">
                                                <label className="text-muted small mb-1 d-block fw-medium">
                                                    {field.label}
                                                </label>
                                                <div className="text-dark fw-semibold">
                                                    {field.value}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Card.Body>
                </Card>
            ))}

        
        </div>
    );
};

export default ProjectView;




